import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play_solid",
  "use": "play_solid-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"play_solid\"><path d=\"M21.728 10.702L5.619 1.5a1.738 1.738 0 00-.868-.234c-.917 0-1.759.734-1.759 1.759v17.95a1.76 1.76 0 001.759 1.759c.29 0 .587-.073.868-.234l16.109-9.201a1.496 1.496 0 000-2.597z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol